import { CapabilityGate, SubCapabilityKey } from "@next-platform/client-common-core/infra/application/capabilities";

import ShareModal, { ShareModalProps } from "./ShareModal";

export default function CapabilityShareCharacterModal(props: ShareModalProps) {
  return (
    <CapabilityGate capability={SubCapabilityKey.CharacterShareLink}>
      <ShareModal {...props} />
    </CapabilityGate>
  );
}
